import { initializeApp } from "firebase/app";
import { addDoc, collection, getFirestore, Timestamp } from "firebase/firestore/lite";
import { FC, useEffect } from "react";
import { useAuth } from "../../../modules/auth";

const HopScotchGameWrapper : FC = () => {
    
    const firebaseConfig = {
        apiKey: "AIzaSyDnyomA90Kg1yrELokYx02jOHRs_Cm7LGc",
        authDomain: "gj08-6e7ea.firebaseapp.com",
        projectId: "gj08-6e7ea",
        storageBucket: "gj08-6e7ea.appspot.com",
        messagingSenderId: "527457566258",
        appId: "1:527457566258:web:da78475eabd5ae580b062b",
        measurementId: "G-KGVQ6TS2WV"
    };
    // Firebase variables
    const firebaseApp = initializeApp(firebaseConfig);
    const firebaseDB = getFirestore(firebaseApp);
    const { currentUser } = useAuth();

    useEffect(() => {
        // On user Tap to play game a postMessage event will be triggered and on parent app we listen to that event
        window.addEventListener("message", function (e) {
            if(e.data.type === 'play') {
                addUserStarRatingInFirebaseDB('onplay', 5);
            }
        });
    });

    const addUserStarRatingInFirebaseDB = async (rewardType:any, score:any) => {
        try {
            // Set start rating into starRatingList colection with primary key as user uid
            const starRatingRef = await addDoc(collection(firebaseDB, "starRatingList"), {
                user_id: currentUser!.id,
                gameName: 'hop_scotch', // all unique game name store in games collection
                rating: score, // Add 5 rating on each time when user play each time
                type: rewardType,
                datetime: Timestamp.fromDate(new Date()).toDate(),
            });
            console.log("Hop Scotch Game Rating added in firestore with ID:: ", starRatingRef.id);
        } catch (error) {
            console.error("Error updating Hop Scotch Game Rating in firestore: ", error);
        }
    }

    return (
        <>
            <div className="row mt-4 game-full-screen">
                <iframe title="Hop Scotch Game" className='responsive-iframe' src="https://hop-scotch.netlify.app"></iframe>
            </div>
        </>
    )
}

export { HopScotchGameWrapper } 